// extracted by mini-css-extract-plugin
export var lineHeightMd = "LineHeights-module--line-height-md--3568d";
export var lineHeightSm = "LineHeights-module--line-height-sm--44d24";
export var lineHeightXl = "LineHeights-module--line-height-xl--9cbf3";
export var lineHeightXs = "LineHeights-module--line-height-xs--ac5e4";
export var lineHeightXxl = "LineHeights-module--line-height-xxl--de494";